module.exports = __webpack_public_path__ + "bb69f0e8fbb0360f2f3db44943842159.MP3";